import React from "react";
import { Link } from "react-router-dom";
import images from "../../assets/images/Constant";

export default function Banner({
  title,
  currentLabel,
  backgroundImage = images.hero,
  homeLabel = "Home",
  homePath = "/",
  heightClassName = "h-[400px] md:h-[362px]",
}) {
  return (
    <section className={`relative ${heightClassName} w-full`}>
      <img
        src={backgroundImage}
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />

      <div className="absolute inset-0 bg-black/50" />

      <div className="relative z-10 max-w-[1200px] mx-auto h-full flex flex-col justify-center items-center text-center text-white px-4 sm:px-6">
        <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold leading-tight">{title}</h1>

        <p className="mt-3 text-sm sm:text-base md:text-lg text-gray-200">
          <Link to={homePath} className="hover:text-white">
            {homeLabel}
          </Link>{" "}
          / <span className="text-blue-400">{currentLabel}</span>
        </p>
      </div>
    </section>
  );
}
